import React from "react"
import {findDOMNode} from "react-dom"


import Popover from "../../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position";
import {PopoverAttachmentType} from "../../../../../../gd-components/gd-popover/@const";
import GDUIDatepickerContent from "../../../../../../gd-components/datetime/datepicker/datepicker-content";
import FieldDate from "../../date";
import {toMomentDate} from "../../../../../../gd/convert/moment-date";

const debug = false
// const debug = "FieldDate_Popover"

type Props = {
    parent      : any,
    field       : FieldDate
    value       : Moment | null
}

export default function FieldDate_Popover(props:Props) {

    const onSelect = (moment:Moment|null) => {
        debug && console.log("onSelect date=", moment)

        // this is important becuase this is how when we save custom field it becomnes YYYY-MM-DD
        // some field extend field date which are not date only but they are read only - and let's use FieldDatetime I guess for them in future
        const momentDate : MomentDate | null = toMomentDate(moment)

        // console.log(momentDate)
        // console.log(momentDate?._dateOnly)
        // console.log(momentDate?.toJSON)

        props.parent.hidePopover();

        // props.parent.onValueChange(userLocalMoment)
        props.parent.onValueChange(momentDate)
    }

    debug && console.log(debug, 'render', props.value)

    // we need to make a date out of it
    const value : MomentDate | undefined = props.value ? momentDate(props.value) : undefined

    const popoverPosition = new PopoverPosition({
        attachment      : "top center",
        targetAttachment: "bottom center",
        attachmentType  : PopoverAttachmentType.FULL,
    })

    return (
        <Popover position           = {popoverPosition}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}>
            <GDUIDatepickerContent value        = {value}
                               onSelect     = {onSelect}
                               minDate      = {props.field.minDate}
                               maxDate      = {props.field.maxDate}/>
        </Popover>
    )
}
